module.exports = __webpack_public_path__ + "img/5.46af1bb5.png";